import React, { Component } from 'react';
import AttachmentTable from './AttachmentTable'
import NewAttachmentModal from './NewAttachmentModal'
import {downloadAttachment} from "../../actions";

class AttachmentsContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showUpload: false
        }
    }
    toggleModalUpload() {
        this.setState({
            showUpload: !this.state.showUpload
        })
    }
    render(){
        if(!this.props.attachments){
            return <script></script>
        }
        return(
            <div style={{marginTop: "30px"}}>
                <h4 className="text-secondary"><i className="text-primary fa fa-file-o" /> Archivos del caso </h4>
                <hr />
                {this.props.attachments.photos.length === 0 &&
                this.props.attachments.dicoms.length === 0 &&
                this.props.attachments.radios.length === 0 ?
                    <div className="alert alert-info">No se han subido archivos del caso</div>
                        :
                    <div>
                        <AttachmentTable
                            title="Fotografías"
                            type="photos"
                            attachments={this.props.attachments}
                            actionDelete={this.props.actionDelete.bind(this)}
                            showAttachment={this.props.showAttachment.bind(this)}
                            downloadAttachment={this.props.downloadAttachment.bind(this)}
                        />
                        <AttachmentTable
                            title="Radiografías"
                            type="radios"
                            attachments={this.props.attachments}
                            actionDelete={this.props.actionDelete.bind(this)}
                            showAttachment={this.props.showAttachment.bind(this)}
                            downloadAttachment={this.props.downloadAttachment.bind(this)}
                        />
                        <AttachmentTable
                            title="DICOM o STL"
                            type="dicoms"
                            attachments={this.props.attachments}
                            actionDelete={this.props.actionDelete.bind(this)}
                            showAttachment={this.props.showAttachment.bind(this)}
                            downloadAttachment={this.props.downloadAttachment.bind(this)}
                        />
                    </div>
                }
                <h4 className="text-secondary"><i className="text-primary fa fa-envelope-o" /> Buzón de archivos
                    <button
                        onClick={ this.toggleModalUpload.bind(this) }
                        className="btn btn-primary pull-right">
                        Subir archivos
                    </button></h4>
                <hr />
                {this.props.attachments.boxes.length === 0 ?
                    <div className="alert alert-info">No se han subido archivos al buzón</div>
                    :
                    <AttachmentTable
                        title="Archivos del buzón"
                        type="boxes"
                        attachments={this.props.attachments}
                        actionDelete={this.props.actionDelete.bind(this)}
                        userId={this.props.userId}
                        showAttachment={this.props.showAttachment.bind(this)}
                        downloadAttachment={this.props.downloadAttachment.bind(this)}
                        isAdmin={this.props.isAdmin}
                    />
                }
                <NewAttachmentModal
                    toggler={this.toggleModalUpload.bind(this)}
                    show={this.state.showUpload}
                    casoId={this.props.casoId}
                />
            </div>
        )
    }
}

export default AttachmentsContainer;


// WEBPACK FOOTER //
// ./resources/assets/js/components/attachments/AttachmentsContainer.jsx